function initFaqAccordion(container) {
  container.querySelectorAll('.faq-item').forEach((item) => {
    const trigger = item.querySelector('.faq-trigger');
    const panel = item.querySelector('.faq-panel');
    if (!trigger || !panel || trigger.dataset.faqBound) return;
    trigger.dataset.faqBound = 'true';

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      item.closest('.faq-accordion')
        .querySelectorAll('.faq-item.is-open')
        .forEach((openItem) => {
          openItem.classList.remove('is-open');
          openItem.querySelector('.faq-trigger').setAttribute('aria-expanded', 'false');
          openItem.querySelector('.faq-panel').style.maxHeight = null;
        });

      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}

document.querySelectorAll('.faq').forEach(initFaqAccordion);

document.addEventListener('shopify:section:load', (event) => {
  const faq = event.target.querySelector('.faq');
  if (faq) initFaqAccordion(faq);
});
